import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const importManagementService = {};

// List Import
importManagementService.listImport = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = ["id", "maker_id", "maker_date", "record_status", "object_type", "resource_id", "auth_status", "exception"];

  return fetchV2({
    url: `${env.API_MSP}/imports`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker,resource",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// List Import Type
importManagementService.listImportTypes = () => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/import-type`,
    method: "get",
  });
};

// Download Report
importManagementService.downloadImport = ({
  fileId = undefined,
  fileName = "",
}) => {
  return fetchV2({
    url: `${env.API_MSP}/resource-global/preview/${fileId}`,
    method: "get",
  });
};

// Download Template
importManagementService.downloadImportTemplate = ({
  fileId = undefined,
  fileName = "",
}) => {
  return fetchV2({
    url: `${env.API_MSP}/imports/template/${fileId}`,
    method: "get",
    responseType: "blob",
  });
};

// Upload Resource
importManagementService.uploadResource = data => {
  return fetchV2({
    url: `${env.API_MSP}/resource-global/upload-file`,
    method: "post",
    data,
  });
};

// Upload Import
importManagementService.uploadImport = data => {
  return fetchV2({
    url: `${env.API_MSP}/imports`,
    method: "post",
    data,
  });
};

// Import Detail
importManagementService.importDetail = ({importId}) => {
  return fetchV2({
    url: `${env.API_MSP}/imports/${importId}`,
    method: "get"
  });
};


export default importManagementService;
